import { cloneDeep } from 'lodash';

class SelectExtrasController {

    $onInit () {
        const free = cloneDeep(this.options.free) || [];
        const paid = cloneDeep(this.options.paid) || [];
        this.extras = free.concat(paid);
    }

    toggle (param) {
        this[param] = !this[param];
    }

    groupBy (item) {
        return item.base_price > 0 ? 'Paid' : 'Free';
    }

    removeExtra (extra) {
        const index = this.guest.item_children.findIndex(item => {
            if (item.type_name === 'EventExtra'
                && item.id === extra.id) {
                return true;
            }
        });

        if (index > -1) {
            this.guest.item_children.splice(index, 1);
        }
    }

    selectExtra (extra) {
        if (!this.extraSelected(extra)) {
            this.guest.item_children.push(extra);
        }

        this.extra = null;
    }

    extraSelected (extra) {
        if (!extra || !extra.id) {
            return false;
        }

        return !!this.guest.item_children.find(item => {
            return item.type_name === 'EventExtra'
                && item.id === extra.id;
        });
    }

    optionsSelected () {
        return this.guestExtras().length || 0;
    }

    guestExtras () {
        return this.guest.item_children.filter(item => {
            return item.type_name === 'EventExtra';
        });
    }
}

SelectExtrasController.$inject = [];

export default SelectExtrasController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/controllers/select.extras.controller.js